export { PurchasesContainer as Purchases } from './PurchasesContainer.js';
